import { render, staticRenderFns } from "./CalendarOverview.vue?vue&type=template&id=d2776c28&scoped=true"
import script from "./CalendarOverview.vue?vue&type=script&lang=ts"
export * from "./CalendarOverview.vue?vue&type=script&lang=ts"
import style0 from "./CalendarOverview.vue?vue&type=style&index=0&id=d2776c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2776c28",
  null
  
)

export default component.exports